const raf = typeof window !== 'undefined' && window.requestAnimationFrame
  ? window.requestAnimationFrame.bind(window)
  : (fn) => setTimeout(fn, 0);

export function nextFrame(fn) {
  raf(() => raf(fn));
}